export default __webpack_public_path__ + "static/media/100_19081.3618237a.jpg";